module.exports = require("@swa-ui/placements/src/FeatureItem/FeatureItem.module.scss");